var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.778,
    height: 22.222,
    viewBox: "0 0 27.778 22.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8f003c;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "web_FILL0_wght400_GRAD0_opsz48",
    className: "cls-1",
    d: "M6.083,30.222A2,2,0,0,1,4.625,29.6,2,2,0,0,1,4,28.139V10.083a2,2,0,0,1,.625-1.458A2,2,0,0,1,6.083,8H29.694a2.136,2.136,0,0,1,2.083,2.083V28.139a2.136,2.136,0,0,1-2.083,2.083Zm0-2.083H22.09v-5.66H6.083Zm18.09,0h5.521v-13.4H24.174ZM6.083,20.4H22.09v-5.66H6.083Z",
    transform: "translate(-4 -8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPage);
export default __webpack_public_path__ + "static/media/add-page.116b90fecf0e2606d408acc9796b6485.svg";
export { ForwardRef as ReactComponent };